<div class="price-option">
<img src="/assets/pricing/{{this.option}}.png" />
</div>
